// extracted by mini-css-extract-plugin
export default {"Emojify":"bbh_a bhg_g"};